"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LengthPrefixedFrameDecoder = exports.toLengthPrefixedFrame = void 0;
const stream_1 = require("stream");
// If you change this you also need to change `writeUint32BE` and `readUInt32BE` in the code below
const HEADER_LENGTH = 4;
/**
 * Utilities to deal with length-prefixed frames, i.e. | length [4 bytes] | payload [variable bytes] |
 */
const toLengthPrefixedFrame = (payload) => {
    const length = Buffer.alloc(HEADER_LENGTH);
    length.writeUint32BE(payload.length);
    return Buffer.concat([length, payload]);
};
exports.toLengthPrefixedFrame = toLengthPrefixedFrame;
class LengthPrefixedFrameDecoder extends stream_1.Transform {
    buffer = Buffer.alloc(0);
    constructor() {
        super({ objectMode: true });
    }
    _transform(chunk, _encoding, callback) {
        this.buffer = Buffer.concat([this.buffer, chunk]);
        this.processStreamData(callback);
    }
    _flush(callback) {
        // Handle any remaining data when the stream ends
        this.processStreamData(callback);
    }
    processStreamData(callback) {
        while (this.buffer.length >= HEADER_LENGTH) {
            const payloadSize = this.buffer.readUInt32BE(0);
            if (this.buffer.length >= payloadSize + HEADER_LENGTH) {
                const payload = this.buffer.subarray(HEADER_LENGTH, payloadSize + HEADER_LENGTH);
                this.push(payload);
                this.buffer = this.buffer.subarray(payloadSize + HEADER_LENGTH);
            }
            else {
                break;
            }
        }
        callback();
    }
}
exports.LengthPrefixedFrameDecoder = LengthPrefixedFrameDecoder;
//# sourceMappingURL=lengthPrefixedFrameUtils.js.map